/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Security, SecureRoute, LoginCallback } from '@okta/okta-react';

import { Container } from 'semantic-ui-react';
import config from './config';
import Home from './Home';
import MasterFrame from './MasterFrame';

import { Provider } from "react-redux";
import store from './redux/store/index';

const App = () => (
  <Provider store={store}>
	  <Router>
	    <Security {...config.oidc}>
	      <Container>
	        <Route path="/" exact component={Home} />
	        <Route path="/implicit/callback" component={LoginCallback} />
	        <SecureRoute path="/dashboard" component={MasterFrame} />
	        <SecureRoute path="/project" component={MasterFrame} />
	        <SecureRoute path="/snippets" component={MasterFrame} />
	      </Container>
	    </Security>
	  </Router>
  </Provider>
);
export default App;
